import React, {Component} from "react";
import TopNav from "../../../common/nav/TopNav";
import Footer from "../../../common/Footer";
import PageBlock from "../../../common/PageBlock";

class About extends Component {
    render() {
        return (
            <div>
                <TopNav tab="docs"/>

                <PageBlock>
                    <div className="container">

                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="page-header">About us</h1>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <p>
                                    At Gatehill Software, we've been building software for over two decades to help people make the most of their time.
                                </p>
                                <h3>Our mission</h3>
                                <p>
                                    We believe development tools should make your life easier. You should be able to trust your tools,
                                    be more productive and have a happier development experience. We work hard to make our products deliver on this ambition.
                                </p>
                                <p>
                                    We produce tools for forward-thinking software developers.
                                </p>
                                <h3>Find out more</h3>
                                <p>
                                    If you’d like to learn more about us,
                                    find us at <a href="https://www.gatehill.io/about">gatehill.io</a>.
                                </p>
                                <h3>Acknowledgements</h3>
                                <p>
                                    Some of the beautiful artwork is thanks to some very talented humans:
                                </p>
                                <ul>
                                    <li><a href="https://stocksnap.io/photo/macbook-laptop-DWLWL9USBG">Photo</a> by <a href="https://stocksnap.io/author/26765">Lia Leslie</a> on <a href="https://stocksnap.io">StockSnap</a></li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </PageBlock>

                <Footer />
            </div>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./src/modules/views/docs/about/About.js